import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepStatus,
  StepTitle,
  Stepper,
  StepperProps,
} from '@chakra-ui/react'
import RadioButton from '../../assets/icons/Radio.svg'

interface ProgressStepperProps {
  currentStep: number
  steps: { title: string; description: string }[]
  orientation?: StepperProps['orientation']
  height?: StepperProps['height']
  onStepChange: (step: number) => void
}

const ProgressStepper = ({
  steps,
  currentStep,
  orientation = 'horizontal',
  height,
  onStepChange,
}: ProgressStepperProps) => {
  return (
    <>
      <Stepper
        index={currentStep - 1}
        orientation={orientation}
        height={height}
        colorScheme="gray"
      >
        {steps.map((step, index) => (
          <Step key={index}>
            <StepIndicator
              onClick={() => onStepChange(index + 1)}
              bg="gray.900"
              rounded="full"
              className="border-none"
            >
              <StepStatus
                complete={<StepIcon />}
                incomplete={
                  <img src={RadioButton} alt="Radio Icon" width={20} height={20} />
                }
                active={<img src={RadioButton} alt="Radio Icon" width={20} height={20} />}
              />
            </StepIndicator>

            {orientation === 'vertical' ? (
              <Box flexShrink="0">
                <StepTitle
                  style={{
                    fontWeight: '800',
                  }}
                >
                  {step.title}
                </StepTitle>
                <StepDescription
                  style={{
                    fontWeight: '500',
                    color: '#ADB5BD',
                  }}
                >
                  {step.description}
                </StepDescription>
              </Box>
            ) : null}
          </Step>
        ))}
      </Stepper>
    </>
  )
}

export default ProgressStepper
